package com.shadowings.gero.data.lessons.chapter15

import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.ImageKeyboardContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.abydos_name_ab01
import gero.composeapp.generated.resources.abydos_name_ab02
import gero.composeapp.generated.resources.abydos_name_ab03
import gero.composeapp.generated.resources.abydos_name_ab05
import gero.composeapp.generated.resources.abydos_name_ab06
import gero.composeapp.generated.resources.abydos_name_ab08
import gero.composeapp.generated.resources.abydos_name_ab14
import gero.composeapp.generated.resources.abydos_name_ab15
import gero.composeapp.generated.resources.abydos_name_ab18
import gero.composeapp.generated.resources.abydos_name_ab20
import gero.composeapp.generated.resources.exp_content_nomi_importanti_1
import gero.composeapp.generated.resources.exp_content_nomi_importanti_2
import gero.composeapp.generated.resources.exp_content_nomi_importanti_3
import gero.composeapp.generated.resources.exp_content_nomi_importanti_4
import gero.composeapp.generated.resources.exp_content_nomi_importanti_5
import gero.composeapp.generated.resources.exp_content_nomi_importanti_6
import gero.composeapp.generated.resources.exp_content_nomi_importanti_7
import gero.composeapp.generated.resources.exp_content_nomi_importanti_8
import gero.composeapp.generated.resources.exp_content_nomi_importanti_9
import gero.composeapp.generated.resources.exp_content_nomi_importanti_10
import gero.composeapp.generated.resources.exp_title_nomi_importanti

fun getNomiImportantiContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_nomi_importanti,
            content = Res.string.exp_content_nomi_importanti_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_nomi_importanti,
            content = Res.string.exp_content_nomi_importanti_2,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_nomi_importanti,
            content = Res.string.exp_content_nomi_importanti_3,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_nomi_importanti,
            content = Res.string.exp_content_nomi_importanti_4,
            face = Faces.Perfect,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_nomi_importanti,
            content = Res.string.exp_content_nomi_importanti_5,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_nomi_importanti,
            content = Res.string.exp_content_nomi_importanti_6,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_nomi_importanti,
            content = Res.string.exp_content_nomi_importanti_7,
            face = Faces.Doubt,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_nomi_importanti,
            content = Res.string.exp_content_nomi_importanti_8,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_nomi_importanti,
            content = Res.string.exp_content_nomi_importanti_9,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_nomi_importanti,
            content = Res.string.exp_content_nomi_importanti_10,
            face = Faces.Perfect,
            character = Characters.Alyn,
        )
    )
}

// Throne names from the Abydos King List: image code (see InscriptionImages), words.tsv id
// (source of the reading), name as usually rendered.
private val abydosNames = listOf(
    Triple("ab01", "MENI", Res.string.abydos_name_ab01),
    Triple("ab02", "TETI", Res.string.abydos_name_ab02),
    Triple("ab03", "ITI", Res.string.abydos_name_ab03),
    Triple("ab05", "SEPTI", Res.string.abydos_name_ab05),
    Triple("ab06", "MERIBIAP", Res.string.abydos_name_ab06),
    Triple("ab08", "QEBEH", Res.string.abydos_name_ab08),
    Triple("ab14", "DJADJAY", Res.string.abydos_name_ab14),
    Triple("ab15", "NEBKA", Res.string.abydos_name_ab15),
    Triple("ab18", "SEDJES", Res.string.abydos_name_ab18),
    Triple("ab20", "SNEFRU", Res.string.abydos_name_ab20),
)

// These names are never explained in the lesson (showing them would give the quiz answers away),
// so the Compendio unlocks them from here once the lesson is completed.
val nomiImportantiQuizWordIds: Set<String> = abydosNames.map { it.second }.toSet()

fun getNomiImportantiQuizContent(words: List<Word>): List<IQuizContent> =
    abydosNames.shuffled().mapNotNull { (imageCode, wordId, name) ->
        val word = words.firstOrNull { it.id == wordId } ?: return@mapNotNull null
        ImageKeyboardContent(
            imageCode = imageCode,
            reading = word.reading.lowercase().map { it.toString() },
            translation = name
        )
    }
